import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadLocations = async () => {
  try {
    const response = await Axios.get('locations');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadLocation = async (action) => {
  try {
    switch (action) {
      case 'new':
        // const response = await Axios.get('setups/product-categories');
        // const responseData = await response.data;
        // return {...responseData, category: {}};
        return {};
        
      default:
        const respnse = await Axios.get('locations/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useLocationAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('locations', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('location_created', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('locations/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('location_update', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useLocationAPI;


